type Dictionary = Record<string, any>;

/**
 * @function setPath
 * @desc Set values in javascript objects by specifying a path string with dot notation. If the path
 * doesn't exist yet, it will be created.  Example:
 * @example
 * const bob = { a: 1 };
 * setPath(bob, 'b.c', 2);
 * // bob is now { a: 1, { b: { c: 2 } } }
 *
 * if obj param is not an object or is null, it returns the original value for obj unaltered.
 *
 * NOTE: THIS MUTATES THE SUPPLIED OBJECT!
 *
 * @param {object} obj   The object to mutate with a new value at the specified dot-notation path.
 * @param {string} path  A dot notation path. ie "a.b.c.fred.booberries"
 * @param {any} value A value to set at the specified object path.
 */
const setPath = (
  obj: Dictionary = {},
  path: string | null,
  value: any
): Dictionary => {
  const newObj: Dictionary = obj;
  let newPath: string[] | string = [];

  if (typeof path === 'string') {
    newPath = path.split('.');
  }

  if (Array.isArray(newPath) && newPath.length > 0) {
    const key = newPath[0];
    if (newPath.length > 1) {
      newPath.shift();
      newObj[key] = setPath(newObj[key], newPath.join(), value);
    } else {
      newObj[key] = value;
    }
  }

  return newObj;
};

export default setPath;

/*
Original version credit to: https://github.com/skratchdot/object-path-set
Satisfying his MIT liscence...

Copyright (c) 2014 skratchdot

Permission is hereby granted, free of charge, to any person
obtaining a copy of this software and associated documentation
files (the "Software"), to deal in the Software without
restriction, including without limitation the rights to use,
copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the
Software is furnished to do so, subject to the following
conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
OTHER DEALINGS IN THE SOFTWARE.
*/
